export default __webpack_public_path__ + "static/media/error-icon.78fd8aff.svg";